<template>
  <div>
    <QuestionLabel data-test="title"
                   class="mb-4"
                   :label="`${inputPath}.label`"
                   :error-message="errorMessage"/>

    <div class="d-flex justify-space-between gap">
      <v-card outlined
              data-test="card"
              v-for="option in rule.getOptions()"
              :key="option"
              :disabled=disabledCard[option]
              :data-cy="`${option}Button`"
              class="d-flex flex-column justify-space-between pa-3 same-size card card-effect"
              :class="{ selected: input === option, 'has-error': hasErrors }"
              @click="selectOption(option)">
        <v-img data-test="picture" max-height="70%" contain :src="`${imagesFolder}/${option}.svg`"/>

        <span class="text-center text-blue">{{ $t(`${inputPath}.${option}.label`) }}</span>

        <HelpTooltip data-test="card-help" class="help" :label="`${inputPath}.${option}.help`"/>
      </v-card>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { EnumRule } from '@/classes/rules/EnumRule';
import { InternationalizedLabel } from '@/interfaces/InternationalizedLabel';
import QuestionLabel from '@/components/Questions/QuestionLabel.vue';
import HelpTooltip from '@/components/HelpTooltip.vue';

@Component({
  components: { HelpTooltip, QuestionLabel }
})
export default class QuestionCards extends Vue {
  @Prop({ required: true, type: String })
  public readonly inputPath!: string;

  @Prop({ required: true, type: String })
  public readonly imagesFolder!: string;

  @Prop({ required: true, type: EnumRule })
  public readonly rule!: EnumRule;

  @Prop({ type: String })
  public readonly input: string | undefined;

  @Prop({ type: [String, Object], default: null })
  public readonly errorMessage!: InternationalizedLabel | null;

  @Prop({ type: [Object], default: false })
  public readonly disabledCard!: object;

  public selectOption(option: string): void {
    this.$emit('setInput', option);
  }

  get hasErrors(): boolean {
    return this.errorMessage !== null;
  }
}
</script>

<style scoped lang="scss">
@import '../../main';

.same-size {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
}
.card:focus:before {
  opacity: 0;
}
.gap {
  gap: 1rem;
}
.text-blue {
  color: $blue-title;
}
.selected {
  border-color: $blue;
  border-width: 2px;
}
.card.selected {
  border: 3px solid $blue;
}
.has-error {
  border-color: $red;
}
.card.has-error {
  border-color: $red;
}
.help {
  position: absolute;
  top: 3%;
  right: 5%;
}
.card-effect {
  transform: translateY(0px);
  transition: transform 0.5s,
              box-shadow 0.5s;

  &:hover {
    box-shadow: 0 0 10px -3px $grey;
    transform: translateY(-2px);
    transition: transform 0.5s ease-out,
                box-shadow 0.5s ease-out;
  }
}
</style>
